import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupWordFormComponent } from './group-word-form/group-word-form.component';
import { GroupWordViewComponent } from './group-word-view/group-word-view.component';
import { GroupWordListComponent } from './group-word-list/group-word-list.component';
import { MaterialModule } from '../material/material.module';
import { GroupWordCardComponent } from './group-word-card/group-word-card.component';
import { ComponentsModule } from '../components/components.module';

@NgModule({
  declarations: [GroupWordFormComponent, GroupWordViewComponent, GroupWordListComponent, GroupWordCardComponent],
  imports: [CommonModule, MaterialModule, ComponentsModule],
})
export class GroupWordModule {}
